const words = {
  spanish: {
    title: "Atracciones",
    content: "Disfruta de nuestras instalaciones para niños y adultos:",
    games: "PARQUE INFANTIL",
    volley: "CANCHA DE VOLEY-VERDE",
    football: "CANCHA DE MICRO FÚTBOL",
    animals: "TERNEROS",
    lake: "LAGO CON GANSOS",
    horses: "CABALLOS PARA CABALGATAS",
  },
  english: {
    title: "Attractions",
    content: "Enjoy our playzone for children and adults",
    games: "PLAY ZONE",
    volley: "VOLLEYBALL FIELD",
    football: "FOOTBALL FIELD",
    animals: "COW CALVES",
    lake: "GEESE LAKE",
    horses: "HORSE RIDING",
  },
};

export default words;
